<template>
    <div class="main">
        <HeaderComponent
            v-if="this.$route.params.price_id"
            style="margin-top:100px;"
            :text="$t('text.edit_price')"
            backgroundColor="#fff"
        />
        <HeaderComponent
            v-if="!this.$route.params.price_id"
            style="margin-top:100px;"
            :text="$t('text.create_price')"
            backgroundColor="#fff"
        />
        <Transition appear name="fade">        
            
        </Transition>
            
        <Transition appear name="fade">
            <div class="body-container">
                
                <div v-if="loading" class="loader-container" style="text-align: center; margin-top:80px;">
                    <b-spinner
                        variant="dark"
                        label="Spinning"
                        class="login-loader"
                    ></b-spinner>
                </div>
                <b-form @submit="onSubmit" v-if="!loading">
                    <b-form-group :label="$t('text.name')">
                        <b-form-input
                        v-model="form.name"
                        :placeholder="$t('text.enter_name')"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group :label="$t('text.display_name')">
                        <b-form-input
                        v-model="form.display_name"
                        :placeholder="$t('text.enter_name')"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group :label="$t('text.display_name_en')">
                        <b-form-input
                        v-model="form.display_name_en"
                        :placeholder="$t('text.enter_name')"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group :label="$t('text.cabin')">
                        <b-form-select
                        v-model="form.cabin"
                        :options="cabins"
                        required
                        ></b-form-select>
                    </b-form-group>

                    <b-form-group :label="$t('text.weeks_input_info')">
                        <b-form-input
                        v-model="form.weeks_string"
                        :placeholder="$t('text.enter_weeks')"
                        required
                        ></b-form-input>
                        <b-form-invalid-feedback :state="weeksValidation">
                            {{ $t('text.weeks_format_error') }}
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group :label="$t('text.price_day')">
                        <b-form-input
                        v-model="form.price_day"
                        :placeholder="$t('text.enter_price')"
                        type="number"
                        required
                        ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('text.price_week')">
                        <b-form-input
                        v-model="form.price_week"
                        :placeholder="$t('text.enter_price')"
                        type="number"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group :label="$t('text.price_sun_to_thur')">
                        <b-form-input
                        v-model="form.price_sun_to_thur"
                        :placeholder="$t('text.enter_price')"
                        type="number"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group :label="$t('text.price_thur_to_sun')">
                        <b-form-input
                        v-model="form.price_thur_to_sun"
                        :placeholder="$t('text.enter_price')"
                        type="number"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group>
                        <b-row style="height: 30px;">
                            <b-col>
                                <b-form-checkbox
                                style="float:left;"
                                id="checkbox-1"
                                v-model="form.block_partial_periods"
                                ></b-form-checkbox>
                                <p>{{ $t('text.block_partial_periods') }}</p>
                            </b-col>
                            <b-col style="text-align:right;"> 
                                <a style="margin-right:10px;"
                                v-b-tooltip.hover :title="$t('text.block_partial_periods_info_text')">
                                    <b-icon icon="question-circle"></b-icon>
                                </a>
                            </b-col>
                        </b-row>
                    </b-form-group>
                    
                    <b-button
                    :disabled="!enableSubmitButton" 
                    v-if="!cabin_price"
                    type="submit" 
                    variant="primary">
                        {{ $t('text.create') }}
                    </b-button>
                    <b-button
                    :disabled="!enableSubmitButton" 
                    v-if="cabin_price"
                    type="submit" 
                    variant="primary">
                        {{ $t('text.save') }}
                    </b-button>
                    <b-button 
                    class="submit-button" 
                    v-if="cabin_price"
                    @click="deleteCabinPrice()" 
                    variant="danger">
                        {{ $t('text.delete') }}
                    </b-button>
                </b-form>
            </div>
        </Transition>
    </div>
</template>

<script>
import HeaderComponent from "../components/HeaderComponent.vue";
import CabinApiService from "../../services/cabin_api_service";
import CabinPrice from "../../models/cabin_price";

export default {
    name: "PriceEditPage",
    components: {
        HeaderComponent,
    },
    data() {
        return {
            loading: true,
            cabin_price: null,
            form: {
                name: null,
                display_name: null,
                display_name_en: null,
                cabin: null,
                weeks: null,
                weeks_string: null,
                price_day: null,
                price_week: null,
                price_sun_to_thur: null,
                price_thur_to_sun: null,
                block_partial_periods: false,
            },
            cabins: [
                { text: this.$t('text.family'), value: 0 },
                { text: this.$t('text.large_cabin'), value: 1 },
                { text: this.$t('text.small_cabin'), value: 2 }
            ],
            weeks_error: null,
        };
    },
    computed: {
        enableSubmitButton() {
            return true;
        },
        weeksValidation() {
            if (!this.form.weeks_string) {
                return true
            }
            let week_strings = this.form.weeks_string.split(',')
            for (let i = 0; i < week_strings.length; i++) {
                if (isNaN(week_strings[i])) {
                    return false
                }
            }
            return true;
        }
    },
    methods: {
        async fetchCabinPrice() {
            if (!this.$route.params.price_id) {
                this.loading = false;
                return
            }
            this.loading = true;
            try {
                const data = await CabinApiService.get_cabin_prices_detail(this.$route.params.price_id);
                this.cabin_price = new CabinPrice(data.data);
                this.form = this.cabin_price.toDict()
                this.form.weeks_string = this.form.weeks.toString()
                this.form.weeks = null;
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
        async deleteCabinPrice() {
            this.$bvModal.msgBoxConfirm(
                this.$t('text.are_you_sure_delete_cabin_price'), 
                {
                    okTitle: this.$t('text.delete_cabin_price'),
                    cancelTitle: this.$t('text.cancel'),
                    okVariant: 'danger',
                }
            )
            .then(async value => {
                if (value) {
                    this.loading = true;
                    try {
                        await CabinApiService.delete_cabin_price(this.cabin_price.id);
                        this.loading = false;
                        this.$router.push("/admin/prices")
                    } catch (error) {
                        this.loading = false;
                    }
                }
            })
        },
        async createCabinPrice() {
            this.loading = true;
            this.form.weeks = this.form.weeks_string.split(',').map(Number);
            var payload = this.form
            try {
                await CabinApiService.post_cabin_price(payload);
                this.loading = false;
                this.$router.push("/admin/prices/");
                
            } catch (error) {
                var errorString = this.$t("text.something_went_wrong_try_later")
                if (error.response.status === 400) {
                    errorString = ""
                    for (var key in error.response.data) {
                        errorString += error.response.data[key][0]
                        errorString += " "
                    }
                }
                this.$bvModal.msgBoxOk(errorString, {okVariant: 'danger'})
                this.loading = false;
            }
        },
        async updateCabinPrice() {
            if (!this.cabin_price) { return }
            this.form.weeks = this.form.weeks_string.split(',').map(Number);
            this.$bvModal.msgBoxConfirm(
                this.$t('text.are_you_sure_update_cabin_price'), 
                {
                    okTitle: this.$t('text.save'),
                    cancelTitle: this.$t('text.cancel'),
                }
            )
            .then(async value => {
                if (value) {
                    this.loading = true;
                    var payload = this.form;
                    try {
                        await CabinApiService.patch_cabin_price(this.cabin_price.id, payload);
                        this.loading = false;
                        this.$router.push("/admin/prices/")
                    } catch (error) {
                        var errorString = this.$t("text.something_went_wrong_try_later")
                        if (error.response.status === 400) {
                            errorString = ""
                            for (var key in error.response.data) {
                                errorString += error.response.data[key][0]
                                errorString += " "
                            }
                        }
                        this.$bvModal.msgBoxOk(errorString, {okVariant: 'danger'})
                        this.loading = false;
                    }
                }
            })
        },
        onSubmit(event) {
            event.preventDefault()
            if (!this.weeksValidation) { return }
            if (this.cabin_price) {
                this.updateCabinPrice()
            } else {
                this.createCabinPrice()
            }
            
        },
    },
    created() {
        this.fetchCabinPrice();
    },
    mounted() {
        if (!(this.$store.getters.token_valid && this.$store.getters.isLoggedIn)) {
            this.$router.push({ name: 'login', query: { redirect: this.$router.currentRoute } });
        }
    }

};
</script>

<style scoped>
.main {
  height: 100%;
  background-color: #fff;
}

.body-container {
    text-align: left;
    margin: auto;

    padding-bottom: 100px;
    padding-left: 30px;
    padding-right: 30px;

    max-width: 860px;
}

.submit-button {
    float:right;
}
</style>
